// components/ScrollingLogos.js
import { motion } from "framer-motion";

const contacts = [
  {
    id: 1,
    state: "Lagos",
    tel: "+234 8160300467",
    email: "Lagos@365globalconsulting.com",
    callurl: "tel:+234 8160300467",
    url: "mailto:lagos@365globalconsulting.com",
  },
  {
    id: 2,
    state: "Abuja",
    tel: "+234 7012647743",
    email: "Abuja@365globalconsulting.com",
    callurl: "tel:+234 7012647743",
    url: "mailto:abuja@365globalconsulting.com",
  },
  {
    id: 3,
    state: "Uyo",
    tel: "+234 8167486759",
    email: "Uyo@365globalconsulting.com",
    callurl: "tel:+234 8167486759",
    url: "mailto:uyo@365globalconsulting.com",
  },
  {
    id: 4,
    state: "Kano",
    tel: "+234 7011489807",
    email: "Kano@365globalconsulting.com",
    callurl: "tel:+234 7011489807",
    url: "mailto:kano@365globalconsulting.com",
  },
  {
    id: 5,
    state: "Port Harcourt",
    tel: "+234 7013250504",
    email: "PortHarcourt@365globalconsulting.com",
    callurl: "tel:+234 7013250504",
    url: "mailto:portharcourt@365globalconsulting.com",
  },
  {
    id: 6,
    state: "Enugu",
    tel: "+234 9043251001",
    email: "Enugu@365globalconsulting.com",
    callurl: "tel:+234 9043251001",
    url: "mailto:enugu@365globalconsulting.com",
  },
  {
    id: 7,
    state: "Anambra",
    tel: "+234 7012526738",
    email: "Anambra@365globalconsulting.com",
    callurl: "tel:+234 7012526738",
    url: "mailto:anambra@365globalconsulting.com",
  },
];
  
const TopNav = () => {
  return (
    <div>
      <div className=" bg-primary w-full py-2 ">
        <nav className="flex justify-between items-center py-2 container mx-auto text-white text-sm">
          <div className="flex">
            <ul className="flex">
              <motion.div
                className="flex flex-shrink-0 animate-scroll"
                initial={{ x: 0 }}
                animate={{ x: "-100%" }}
                transition={{ repeat: Infinity, duration: 50, ease: "linear" }}
              >
                {contacts.map((contact) => (
                  <li className="pr-12" key={contact.id}>
                    <span className="font-bold">{contact.state}</span>:{" "}
                    <a href={contact.callurl}>{contact.tel}</a>{" "}
                    {/* <a href={contact.url}>
                      {contact.email}
                    </a> */}
                  </li>
                ))}
              </motion.div>
              <motion.div
                className="flex flex-shrink-0 animate-scroll"
                initial={{ x: 0 }}
                animate={{ x: "-100%" }}
                transition={{ repeat: Infinity, duration: 50, ease: "linear" }}
              >
                {contacts.map((contact) => (
                  <li className="pr-12" key={contact.id}>
                    <span className="font-bold">{contact.state}</span>:{" "}
                    <a href={contact.callurl}>{contact.tel}</a>{" "}
                    {/* <a href={contact.url}>
                      {contact.email}
                    </a> */}
                  </li>
                ))}
              </motion.div>
              {/* <li>
                Lagos tel: <a href="tel:+234 81 25853028">+234 81 25853028</a>
             </li> */}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default TopNav;
